require('../services/common-service.js');
require('../services/navigation-service.js');
require('../controllers/account-ctrl.js');
require('../controllers/header-ctrl.js');
require('../services/help-service.js');
require('../directives/about-directive.js');
require('../services/order-service.js');
require('../directives/feedback-directive.js');
require('../services/app-insights-config-service.js');



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/page-entries/header-entry.js
// module id = 496
// module chunks = 17